import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../components';

const YES_NO = v => (v ? 'Si' : 'No');

const columns = memoize(clickHandler => [
  {
    name: 'NOMBRE DEL DOCUMENTO',
    selector: row => row.name,
    sortable: true,
    grow: 1
  },
  {
    name: 'ARCHIVO',
    selector: row => row.document_info?.clean_filename || '—',
    sortable: false,
    grow: 1.2
  },
  {
    name: 'DOCUMENTO PÚBLICO',
    selector: row => YES_NO(row.is_public),
    sortable: true,
    grow: 1
  },
  {
    name: 'Acciones',
    cell: item => (
      <>
        <ButtonTooltip
          onClick={() => clickHandler(item, 'edit')}
          variant="circle-warning"
          className="btn-circle"
          size="sm"
          text="Editar"
        >
          <Icon icon="pencil" />
        </ButtonTooltip>

        <ButtonTooltip
          onClick={() => clickHandler(item, 'show')}
          variant="circle-info"
          className="btn-circle"
          size="sm"
          text="Ver"
        >
          <Icon icon="eye" />
        </ButtonTooltip>

        <ButtonTooltip
          onClick={() => clickHandler(item, 'download')}
          variant="circle-primary"
          className="btn-circle"
          size="sm"
          text="Descargar"
        >
          <Icon icon="download-2" />
        </ButtonTooltip>

        <ButtonTooltip
          onClick={() => clickHandler(item, 'destroy')}
          variant="circle-danger"
          className="btn-circle"
          size="sm"
          text="Eliminar"
        >
          <Icon icon="trash" />
        </ButtonTooltip>
      </>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    center: true,
    width: '200px'
  }
]);

export default columns;
